<template>
  <div class="home">
    <b-img src="../asssets/titlebar.jpg" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HomeView",
  components: {},
};
</script>
